import API from "../../api/api";
import moment from "moment";

const $API = new API();

const Pathology = {
  state: () => ({
    pathologyEvents: []
  }),
  getters: {
    defaultDates() {
      return {
        startDate: moment(new Date())
          .subtract(3, "week")
          .format("YYYY-MM-DDT00:00:00"),
        endDate: moment().format("YYYY-MM-DDT00:00:00")
      };
    },
    hasUnwatchedPathology(state) {
      return state.pathologyEvents.some(e => e.count == 0);
    }
  },
  mutations: {
    SET_PATHOLOGY_LIST(state, events) {
      state.pathologyEvents = events.map(e => {
        const id = e.file && e.file.path ? e.file.path : "";
        const count = e.doctor_view_count
          ? e.doctor_view_count.doctor_view_count
          : 0;
        return { id, count };
      });
    },
    UPDATE_FILE_WATCHED(state, filePath) {
      const path = filePath.replace(
        "https://md-booking.hmc.co.il/ex-doctor/external",
        ""
      );
      const i = state.pathologyEvents.findIndex(e => e.id == path);
      if (i === -1) return;
      state.pathologyEvents[i].count++;
    }
  },
  actions: {
    async GET_PATHOLOGY_LIST({ commit, getters, rootGetters }, newDates) {
      const isDefaultDate =
        JSON.stringify(newDates) === JSON.stringify(getters.defaultDates);
      let doctorId = rootGetters.activeDoctor.id;
      const dates = newDates ?? getters.defaultDates;

      if (!doctorId) return [];
      const res = await $API.getPathologyList({
        doctorId,
        fromDate: moment(dates.startDate, "YYYY-MM-DDThh:mm:ss").format(
          "YYYY-MM-DD"
        ),
        toDate: moment(dates.endDate, "YYYY-MM-DDThh:mm:ss").format(
          "YYYY-MM-DD"
        )
      });
      if (!res || !res.data || !res.data.data) return [];

      const events = res.data.data.filter(
        e => e.file && e.file.path.includes("pathological-report")
      );
      if (isDefaultDate || !newDates) commit("SET_PATHOLOGY_LIST", events);
      return events;
    }
  }
};

export default Pathology;
